/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProducedMaterialLoadingMode } from '../../models/produced-material-loading-mode';
import { ProducedMaterialsViewModel } from '../../models/produced-materials-view-model';

export interface GetProducedMaterialList$Params {
  productionOrderId: number;
  loadingMode?: ProducedMaterialLoadingMode;
}

export function getProducedMaterialList(http: HttpClient, rootUrl: string, params: GetProducedMaterialList$Params, context?: HttpContext): Observable<StrictHttpResponse<ProducedMaterialsViewModel>> {
  const rb = new RequestBuilder(rootUrl, getProducedMaterialList.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('loadingMode', params.loadingMode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProducedMaterialsViewModel>;
    })
  );
}

getProducedMaterialList.PATH = '/api/v1/Containers/{productionOrderId}/ProducedMaterials';
